import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
/*
Ivo Ribeiro 
exemplo : 
    <mat-input-search 
    matTooltip="Digite o código,email ou nome do fornecedor para pesquisar"
    [placeholder]="'código fornecedor'"
    [list]="fornecedores"
    (keyFinish)="onKeyFinish($event)"
    (value)="codigoFornecedorSelecionado = $event"
    > </mat-input-search>

*/
@Component({
  selector: 'mat-input-search',
  templateUrl: './mat-input-search.component.html',
  styleUrls: ['./mat-input-search.component.scss']
})
export class MatInputSearchComponent implements OnInit {

  @Input() placeholder : string = ''
  _inputSearchText : string = ''
  @Output() value = new EventEmitter<string>() 
  inputKeyUpTimeOutId : any = null  
  @Output() keyFinish = new EventEmitter<string>() 
  isTyping = false
  @Input() list : Array<{codigo : number , nome : string}> = []
  constructor() { }

  ngOnInit() {
  }

  set inputSearchText(vl : string){
     this._inputSearchText = vl
     this.value.emit(vl)
  }
  get inputSearchText(){
    return this._inputSearchText
  }

  onKeyUp(){
    if(typeof this.inputSearchText !== 'string') return
    this.isTyping = true
    this.emitKeyEventAny(1500)

  }

  emitKeyEventAny(mils : number){
      let timeOut = ()=>{
          this.inputKeyUpTimeOutId = 
          setTimeout(()=>{
            if(typeof this.inputSearchText === 'string')
            { this.keyFinish.emit(this.inputSearchText) }
            this.inputKeyUpTimeOutId = null
            this.isTyping = false
          },mils)
      }
      if(!this.inputKeyUpTimeOutId){
        timeOut()
      }
      else{
        clearTimeout(this.inputKeyUpTimeOutId)
        timeOut()
      }
    
    }

}
